(function () {
    'use strict';

    angular
        .module('app')
        .controller('SMSSelectRecipientsDialogCtrl', SMSSelectRecipientsDialogCtrl);

    SMSSelectRecipientsDialogCtrl.$inject = [
        '$scope',
        'DialogInstance',
        'ContactService',
        'sms',
        'viewOnlyMode'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting recipients before a SMS is sent
     */
    function SMSSelectRecipientsDialogCtrl(
        $scope,
        DialogInstance,
        ContactService,
        sms,
        viewOnlyMode) {
        /* jshint validthis:true */
        var vm = this;
        vm.viewOnlyMode = viewOnlyMode;
        vm.title = viewOnlyMode ? 'Recipients' : 'Select Recipients';
        vm.validationReport = [];
        vm.loading = true;
        vm.allRecipientsSelected = true;
        vm.toggleAllRecipients = toggleAllRecipients;
        vm.getContactDetails = getContactDetails;
        vm.cancel = cancel;
        vm.send = send;
        vm.toolTipHtml = toolTipHtml;
        vm.showContactInformation = showContactInformation;

        activate();

        function activate() {
            sms.getValidationReport()
                .then(getValidationReportOk, getValidationReportError);

            function getValidationReportOk(data) {
                vm.validationReport = data;
                toggleAllRecipients();
                vm.loading = false;
            }

            function getValidationReportError(error) {
                vm.error = 'Error loading the SMS validation report.';
                vm.loading = false;
            }

            $scope.$watch('vm.allRecipientsSelected', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    toggleAllRecipients();
                }
            });
        }

        /**
          * Toggles the SMS recipients between selected and not selected.
          */
        function toggleAllRecipients() {
            angular.forEach(vm.validationReport, function (report) {
                angular.forEach(report.SendReports, function (sendReport) {
                    if (!sendReport.ErrorMessage && !_.isNil(sendReport.To)) {
                        sendReport.Selected = vm.allRecipientsSelected;
                    }
                });
            });
        }

        /**
          * Gets the contact information in a user readable format using the supplied contact.
          *
          * @returns {string} Returns user readable contact information.
          */
        function getContactDetails(contact) {
            var result = '';

            if (!_.isNil(contact.Name) && contact.Name !== '') {
                result += contact.Name + ' <' + contact.Value + '>';
            } else {
                result += contact.Value;
            }

            return result;
        }

        function cancel() {
            DialogInstance.cancel();
        }

        /**
          * Generates the send SMS request object and then closes the dialog returning the request object.
          */
        function send() {
            var smsRecipients = [];

            angular.forEach(vm.validationReport, function (report) {
                angular.forEach(report.SendReports, function (sendReport) {
                    if (!sendReport.ErrorMessage && !_.isNil(sendReport.To) && sendReport.Selected) {
                        smsRecipients.push(sendReport);
                    }
                });
            });

            DialogInstance.ok(smsRecipients);
        }

        /**
         *
         * Creates the html code to be shown for the contact tooltip
         *
         * @returns {string} html code describing the supplied contact
         */
        function toolTipHtml(contact) {
            return ContactService.getToolTipHtml(contact);
        }

        /**
         *
         * Checks the contact to determine if a tool tip shown be shown
         *
         * @returns {bool} does the contact contain information that needs to be shown in a tool tip
         */
        function showContactInformation(contact) {
            return ContactService.showContactInformation(contact);
        }
    }
})();
